// ==============================================================================
// PRESETS E DICIONÁRIO OPERACIONAL DOS NICHOS (À LA CARTE)
// Configurações de seletores rápidos (Pills), checklists de vistoria e termos
// ==============================================================================

import { NichePresetDefinition } from '../types';

export const NICHE_PRESETS: Record<string, NichePresetDefinition> = {
  // ────────────────────────────────────────────────────────────────────────────
  // ASSISTÊNCIA TÉCNICA DE CELULARES & ACESSÓRIOS
  // ────────────────────────────────────────────────────────────────────────────
  assistencia_celular: {
    nicheKey: 'assistencia_celular',
    displayName: 'Assistência Técnica de Celulares',
    cluster: 'tecnologia_reparos',
    selectorGroups: [
      {
        id: 'servicos_bancada',
        title: 'Serviços de Bancada & Reparos',
        items: [
          { id: 'troca_tela_original', label: 'Troca de Tela Frontal (Original)', defaultPrice: 450, durationMinutes: 60 },
          { id: 'troca_tela_incell', label: 'Troca de Tela Frontal (Incell / 1ª Linha)', defaultPrice: 250, durationMinutes: 60 },
          { id: 'troca_bateria', label: 'Troca de Bateria Premium', defaultPrice: 180, durationMinutes: 40 },
          { id: 'troca_conector', label: 'Troca do Conector de Carga (Dock/Sub-placa)', defaultPrice: 120, durationMinutes: 45 },
          { id: 'banho_quimico', label: 'Desoxidação / Banho Químico (Aparelho Molhado)', defaultPrice: 150, durationMinutes: 120 },
          { id: 'troca_tampa', label: 'Troca de Tampa Traseira (Laser/Manual)', defaultPrice: 200, durationMinutes: 90 },
          { id: 'reparo_placa', label: 'Reparo Avançado em Placa (Micro-soldagem)', defaultPrice: 350, durationMinutes: 240 },
          { id: 'software', label: 'Reinstalação de Software / Firmware', defaultPrice: 80, durationMinutes: 60 }
        ]
      },
      {
        id: 'acessorios_pdv',
        title: 'Produtos de Balcão & Acessórios (PDV)',
        items: [
          { id: 'pelicula_3d', label: 'Película de Vidro 3D / Cerâmica (com aplicação)', defaultPrice: 35, isMaterial: true },
          { id: 'pelicula_hidrogel', label: 'Película de Hidrogel / UV (com aplicação)', defaultPrice: 50, isMaterial: true },
          { id: 'capa_anti_impacto', label: 'Capa Protetora Anti-impacto / MagSafe', defaultPrice: 45, isMaterial: true },
          { id: 'cabo_turbo', label: 'Cabo USB-C / Lightning Turbo (1m)', defaultPrice: 40, isMaterial: true },
          { id: 'fonte_turbo', label: 'Fonte Carregador Turbo 20W/30W', defaultPrice: 65, isMaterial: true },
          { id: 'fone_tws', label: 'Fone de Ouvido Bluetooth TWS', defaultPrice: 120, isMaterial: true }
        ]
      }
    ],
    defaultChecklists: [
      'Touch Screen e Display (verificado sem manchas/linhas ou toques fantasmas)',
      'FaceID / TouchID / Leitor Biométrico (verificado e funcional)',
      'Câmeras (Traseira, Ultra-wide e Frontal) + Foco e Flash',
      'Microfones (Ligação e Gravação) e Alto-falante / Auricular',
      'Conector de Carga e Carregamento por indução (verificados)',
      'Botões físicos (Power, Volume +/-, Chave Silencioso)',
      'Sinal de Rede Celular (SIM Card) e Conexões Wi-Fi/Bluetooth',
      'Inspeção visual da carcaça (aparelho sem marcas profundas de queda, tela não trincada e tampa traseira íntegra)'
    ],
    defaultWarrantyTerms: `TERMO DE CONTRATO DE SERVIÇO:
1 - O aparelho será entregue a qualquer pessoa que se apresentar portando esta Ordem de Serviço, salvo comunicação de extravio por escrito.
2 - O aparelho e sua procedência são de inteira responsabilidade do cliente perante os órgãos de segurança.
3 - Aparelhos abandonados na assistência por mais de 90 dias após notificação de retirada sofrerão cobrança de 15% ao mês referente à taxa de guarda.
4 - GARANTIA DE 90 DIAS exclusivamente sobre a PEÇA e SERVIÇO descritos nesta ordem (não cobre demais defeitos do aparelho).
5 - A garantia PERDE A VALIDADE em caso de: novas quedas, tela trincada, contato com líquidos ou rompimento do lacre de segurança.
6 - A assistência NÃO se responsabiliza por dados, fotos, contatos ou apps. O backup é dever prévio do cliente.
7 - DESOXIDAÇÃO (Aparelho Molhado): O cliente está ciente de que o valor cobrado refere-se à tentativa de limpeza da placa. NÃO HÁ GARANTIA para este serviço, pois a umidade pode causar falhas em outros componentes a qualquer momento.
8 - Abertura de aparelho perde certificação/vedação original contra água.
9 - O cliente declara estar ciente e de acordo com as normas acima.`,
    defaultPaymentTerms: 'Pagamento à vista (PIX ou Dinheiro) ou parcelado no Cartão de Crédito com acréscimo da maquininha.',
    defaultObservations: [
      'Por favor, forneça a senha de tela para a realização dos testes completos de hardware.',
      'A não aprovação do orçamento pode gerar taxa de diagnóstico técnico em casos de desmontagem complexa.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 0. BARBEARIA, BARBOTERAPIA & CORTE MASCULINO
  // ────────────────────────────────────────────────────────────────────────────
  barbearia: {
    nicheKey: 'barbearia',
    displayName: 'Barbearia & Barboterapia Masculina',
    cluster: 'care_estetica',
    selectorGroups: [
      {
        id: 'servicos_cabelo',
        title: 'Cabelo & Cortes',
        items: [
          { id: 'corte_degrade', label: 'Corte Degradê / Fade / Navalhado', defaultPrice: 45, durationMinutes: 40 },
          { id: 'corte_social_tesoura', label: 'Corte Tradicional / Tesoura', defaultPrice: 40, durationMinutes: 35 },
          { id: 'corte_infantil', label: 'Corte Infantil / Kids Especial', defaultPrice: 40, durationMinutes: 30 },
          { id: 'selagem_masculina', label: 'Selagem / Alinhamento Capilar', defaultPrice: 85, durationMinutes: 60 },
          { id: 'platinado_nevou', label: 'Platinado Global / Nevou com Matização', defaultPrice: 160, durationMinutes: 120 },
          { id: 'lavagem_finalizacao', label: 'Lavagem com Massagem Craniana + Penteado', defaultPrice: 25, durationMinutes: 15 }
        ]
      },
      {
        id: 'servicos_barba',
        title: 'Barba & Cuidados Faciais',
        items: [
          { id: 'barboterapia_completa', label: 'Barboterapia com Toalha Quente & Vapor de Ozônio', defaultPrice: 45, durationMinutes: 40 },
          { id: 'alinhamento_barba', label: 'Alinhamento / Desenho de Barba Simples', defaultPrice: 30, durationMinutes: 20 },
          { id: 'pigmentacao_barba', label: 'Pigmentação / Camuflagem de Barba', defaultPrice: 35, durationMinutes: 25 },
          { id: 'sobrancelha_navalha', label: 'Design de Sobrancelha na Navalha / Pinça', defaultPrice: 20, durationMinutes: 15 },
          { id: 'depilacao_nariz_orelha', label: 'Depilação Nariz e Orelha com Cera Quente', defaultPrice: 25, durationMinutes: 15 }
        ]
      },
      {
        id: 'combos_vip',
        title: 'Combos & Experiências VIP',
        items: [
          { id: 'combo_cabelo_barba', label: 'Combo Cabelo (Fade) + Barboterapia VIP', defaultPrice: 80, durationMinutes: 70 },
          { id: 'combo_completo_noivo', label: 'Experiência Completa (Corte + Barba + Sobrancelha + Massagem)', defaultPrice: 120, durationMinutes: 90 },
          { id: 'combo_pai_filho', label: 'Combo Pai & Filho (2 Cortes com Bebida Cortesia)', defaultPrice: 75, durationMinutes: 60 }
        ]
      },
      {
        id: 'produtos_balcao_pdv',
        title: 'Produtos de Balcão & PDV (Cross-Selling)',
        items: [
          { id: 'pomada_matte', label: 'Pomada Modeladora Efeito Matte (150g)', defaultPrice: 40, isMaterial: true },
          { id: 'oleo_barba_premium', label: 'Óleo Hidratante de Barba (30ml)', defaultPrice: 35, isMaterial: true },
          { id: 'shampoo_mentolado', label: 'Shampoo Anticaspa Mentolado (250ml)', defaultPrice: 38, isMaterial: true },
          { id: 'balm_barba', label: 'Balm Modelador e Refrescante de Barba', defaultPrice: 35, isMaterial: true },
          { id: 'cerveja_artesanal', label: 'Cerveja Artesanal Long Neck / Heineken', defaultPrice: 12, isMaterial: true },
          { id: 'refrigerante_energetico', label: 'Refrigerante em Lata / Energético', defaultPrice: 8, isMaterial: true }
        ]
      }
    ],
    defaultChecklists: [
      'Lâmina descartável nova (1/2 navalhete) aberta na presença do cliente',
      'Higienização e esterilização de tesouras, pentes e máquinas com álcool 70%',
      'Gola higiênica e capa de corte descartável/individual posicionadas',
      'Toalha quente esterilizada para barboterapia com óleo essencial de eucalipto',
      'Finalização com loção pós-barba sem álcool e massagem relaxante'
    ],
    defaultWarrantyTerms: 'Garantia de ajuste ou retoque gratuito do pezinho e alinhamento em até 3 dias úteis.',
    defaultPaymentTerms: 'Pagamento ao final do atendimento via PIX Instantâneo, Cartão de Crédito/Débito ou Dinheiro.',
    defaultObservations: [
      'Tolerância máxima de atraso de 10 minutos para garantir a pontualidade da grade de horários.',
      'Cancelamentos ou reagendamentos podem ser feitos pelo link da vitrine com até 2h de antecedência.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 1. ELETRICISTA & INSTALAÇÕES ELÉTRICAS
  // ────────────────────────────────────────────────────────────────────────────
  eletricista: {
    nicheKey: 'eletricista',
    displayName: 'Eletricista & Instalações Elétricas',
    cluster: 'campo_obras',
    selectorGroups: [
      {
        id: 'equipe',
        title: 'Equipe & Mão de Obra',
        items: [
          { id: 'eletricista_chefe', label: 'Eletricista Responsável (Diária)', defaultPrice: 250, defaultQuantity: 1 },
          { id: 'ajudante_eletrica', label: 'Ajudante Técnico (Diária)', defaultPrice: 130, defaultQuantity: 1 },
          { id: 'hora_emergencial', label: 'Hora Técnica de Emergência (Noturno/FDS)', defaultPrice: 90, defaultQuantity: 2 }
        ]
      },
      {
        id: 'dispositivos',
        title: 'Dispositivos & Painéis',
        items: [
          { id: 'troca_qdt', label: 'Montagem/Revisão de Quadro QDT (Trilho DIN)', defaultPrice: 350 },
          { id: 'instalacao_idr', label: 'Instalação de IDR (Proteção contra Choques)', defaultPrice: 90, isMaterial: true },
          { id: 'instalacao_dps', label: 'Instalação de DPS (Proteção contra Raios)', defaultPrice: 85, isMaterial: true },
          { id: 'circuito_chuveiro', label: 'Passagem de Circuito Exclusivo para Chuveiro (6mm²)', defaultPrice: 180 }
        ]
      },
      {
        id: 'iluminacao_pontos',
        title: 'Iluminação & Pontos',
        items: [
          { id: 'perfil_led', label: 'Instalação de Perfil de LED com Fonte (metro)', defaultPrice: 65, defaultQuantity: 3 },
          { id: 'ponto_tomada', label: 'Ponto Novo de Tomada / Interruptor', defaultPrice: 45, defaultQuantity: 4 },
          { id: 'lustre_pendente', label: 'Montagem de Lustre / Pendente de Teto', defaultPrice: 120 },
          { id: 'padrao_entrada', label: 'Reforma de Padrão de Entrada Concessionária', defaultPrice: 550 }
        ]
      }
    ],
    defaultChecklists: [
      'Disjuntor geral desligado antes do início da intervenção',
      'Teste de continuidade e ausência de tensão efetuado com multímetro',
      'Barramento de Neutro e Barramento de Terra separados e identificados',
      'Aperto correto dos bornes com chave dinamométrica/isolada',
      'Teste do botão de disparo do IDR realizado com sucesso'
    ],
    defaultWarrantyTerms: 'Garantia de 90 dias sobre os serviços de mão de obra elétrica executados, conforme termos da NBR 5410. A garantia não cobre sobrecargas externas causadas pela concessionária ou mau uso de aparelhos de potência incompatível com o circuito.',
    defaultPaymentTerms: 'Entrada 50% no início dos serviços + 50% na entrega e teste final.',
    defaultObservations: [
      'Validade desta proposta: 10 dias corridos a partir da data de emissão.',
      'Materiais elétricos fornecidos pelo cliente devem possuir selo do INMETRO.',
      'Não estão inclusos serviços de alvenaria fina ou pintura de fechamento de rasgos.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 2. ENCANADOR & HIDRÁULICA
  // ────────────────────────────────────────────────────────────────────────────
  encanador: {
    nicheKey: 'encanador',
    displayName: 'Encanador & Bombeiro Hidráulico',
    cluster: 'campo_obras',
    selectorGroups: [
      {
        id: 'servicos_principais',
        title: 'Serviços Hidráulicos',
        items: [
          { id: 'caca_vazamento', label: 'Localização de Vazamento Oculto (Geofone)', defaultPrice: 280 },
          { id: 'reparo_hydra', label: 'Reparo / Troca de Válvula Hydra ou Docol', defaultPrice: 150 },
          { id: 'desentupimento_pia', label: 'Desentupimento de Ramal de Pia / Esgoto', defaultPrice: 160 },
          { id: 'troca_sifao_torneira', label: 'Troca de Sifão e Torneira de Bancada', defaultPrice: 90 },
          { id: 'instalacao_pressurizador', label: 'Instalação de Pressurizador de Água', defaultPrice: 220 }
        ]
      },
      {
        id: 'materiais_tubos',
        title: 'Tubulações & Conexões',
        items: [
          { id: 'tubo_pvc_marrom', label: 'Tubo Soldável PVC 25mm (barra)', defaultPrice: 32, isMaterial: true },
          { id: 'tubo_ppr_quente', label: 'Tubo PPR Água Quente (Termofusão)', defaultPrice: 55, isMaterial: true },
          { id: 'registro_pressao', label: 'Registro de Pressão Base Docol 3/4', defaultPrice: 75, isMaterial: true },
          { id: 'adesivo_soldavel', label: 'Adesivo Plástico para PVC e Fita Veda-Rosca', defaultPrice: 18, isMaterial: true }
        ]
      }
    ],
    defaultChecklists: [
      'Registro geral fechado e linha esgotada antes do corte',
      'Lixamento e limpeza com solução limpadora nas conexões de PVC',
      'Tempo de cura do adesivo respeitado antes do religamento da rede',
      'Teste de estanqueidade sob pressão máxima durante 30 minutos sem gotejamento'
    ],
    defaultWarrantyTerms: 'Garantia de 90 dias sobre vedações e tubulações montadas. Não cobre entupimentos causados por descarte indevido de gordura, papel ou detritos pós-entrega.',
    defaultPaymentTerms: 'Pagamento integral na conclusão dos testes de pressão (PIX ou Cartão).',
    defaultObservations: [
      'Validade da proposta: 7 dias corridos.',
      'Abertura de pisos/paredes será restaurada apenas até a camada de reboco bruto (sem recolocação de azulejo fino salvo orçamento prévio).'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 3. AUDIOVISUAL & PRODUTORA DE VÍDEO (PADRÃO MDFILME)
  // ────────────────────────────────────────────────────────────────────────────
  audiovisual: {
    nicheKey: 'audiovisual',
    displayName: 'Audiovisual, Foto & Produtora de Vídeo',
    cluster: 'projetos_tech',
    selectorGroups: [
      {
        id: 'equipe_tecnica',
        title: 'Equipe Técnica',
        items: [
          { id: 'diretor_cena', label: 'Diretor de Cena (Diária)', defaultPrice: 1800 },
          { id: 'dir_fotografia', label: 'Diretor de Fotografia / DP (Diária)', defaultPrice: 1500 },
          { id: 'op_camera', label: 'Operador de Câmera (Diária)', defaultPrice: 900 },
          { id: 'gaffer_iluminacao', label: 'Gaffer / Chefe de Elétrica (Diária)', defaultPrice: 800 },
          { id: 'op_drone', label: 'Operador de Drone com Homologação ANAC (Diária)', defaultPrice: 1200 },
          { id: 'tecnico_audio', label: 'Técnico de Áudio Direto (Diária)', defaultPrice: 850 }
        ]
      },
      {
        id: 'equipamentos',
        title: 'Equipamentos & Câmeras',
        items: [
          { id: 'camera_cinema', label: 'Câmera Cinema 4K/6K (Red / Sony FX / Blackmagic)', defaultPrice: 1200 },
          { id: 'lentes_cine_prime', label: 'Kit de Lentes Cine Prime', defaultPrice: 700 },
          { id: 'iluminacao_led', label: 'Kit Iluminação LED 5000W com Softboxes', defaultPrice: 650 },
          { id: 'estabilizador_ronin', label: 'Gimbal / Ronin Estabilizador', defaultPrice: 350 }
        ]
      },
      {
        id: 'pos_producao',
        title: 'Pós-Produção & Entregáveis',
        items: [
          { id: 'edicao_video', label: 'Edição & Montagem de Vídeo Principal (até 3 min)', defaultPrice: 1400 },
          { id: 'color_grading', label: 'Color Grading / Tratamento de Cor Avançado', defaultPrice: 800 },
          { id: 'motion_graphics', label: 'Motion Graphics & Vinhetas Animadas 2D', defaultPrice: 650 },
          { id: 'versao_reels', label: 'Cortes Verticais para Reels / TikTok (30s)', defaultPrice: 300, defaultQuantity: 2 },
          { id: 'taxa_condecine', label: 'Emissão e Registro de CRT / CONDECINE', defaultPrice: 450 }
        ]
      },
      {
        id: 'logistica',
        title: 'Logística & Suporte',
        items: [
          { id: 'van_producao', label: 'Transporte / Van de Produção (Diária)', defaultPrice: 600 },
          { id: 'alimentacao_equipe', label: 'Catering / Alimentação de Equipe (por pessoa)', defaultPrice: 75, defaultQuantity: 6 },
          { id: 'locacao_estudio', label: 'Locação de Estúdio com Fundo Infinito', defaultPrice: 1500 }
        ]
      }
    ],
    defaultChecklists: [
      'Briefing e roteiro técnico aprovados previamente pelo cliente',
      'Baterias e mídias de alta velocidade formatadas e checadas',
      'Captação de áudio de backup gravada em canal duplo',
      'Backup de segurança (offload com soma de verificação) realizado ao término das gravações'
    ],
    defaultWarrantyTerms: 'Garantia de entrega dos arquivos finalizados em resolução contratada via link digital com armazenamento seguro por 30 dias após a entrega final. Estão inclusas até 2 (duas) rodadas de alteração na fase de edição; alterações posteriores serão orçadas como horas adicionais.',
    defaultPaymentTerms: 'Condições de pagamento: Entrada 40% no aceite + 30% na gravação + 30% na entrega final (ou 40% + 28 ddl).',
    defaultObservations: [
      'Validade desta proposta: 5 (cinco) dias corridos a partir da emissão.',
      'Arquivos brutos (RAW / Log) não estão inclusos na entrega final, salvo contratação de taxa de cessão.',
      'Custos de locações externas, taxas públicas ou modelos contratados correm por conta do contratante.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 4. CLIMATIZAÇÃO, AR-CONDICIONADO & REFRIGERAÇÃO (HVAC)
  // ────────────────────────────────────────────────────────────────────────────
  hvac: {
    nicheKey: 'hvac',
    displayName: 'Climatização, Ar-Condicionado & Refrigeração',
    cluster: 'campo_obras',
    selectorGroups: [
      {
        id: 'instalacao_split',
        title: 'Instalação de Ar-Condicionado',
        items: [
          { id: 'inst_9_12k', label: 'Instalação Split Hi-Wall 9.000 a 12.000 BTUs', defaultPrice: 380 },
          { id: 'inst_18_24k', label: 'Instalação Split Hi-Wall 18.000 a 24.000 BTUs', defaultPrice: 480 },
          { id: 'inst_cassete_piso', label: 'Instalação Piso-Teto ou Cassete (36k a 60k BTUs)', defaultPrice: 850 },
          { id: 'metro_tubo_extra', label: 'Metro adicional de tubulação de cobre e isolamento', defaultPrice: 85, defaultQuantity: 2 }
        ]
      },
      {
        id: 'manutencao_pmoc',
        title: 'Higienização & Manutenção',
        items: [
          { id: 'limpeza_quimica', label: 'Higienização Completa com Bactericida e Laudo', defaultPrice: 180 },
          { id: 'carga_gas_r410', label: 'Recarga de Fluido Refrigerante R-410A / R-32', defaultPrice: 220 },
          { id: 'troca_capacitor', label: 'Substituição de Capacitor e Teste de Compressor', defaultPrice: 160 },
          { id: 'contrato_pmoc', label: 'Mensalidade de Plano PMOC para Empresas (por máquina)', defaultPrice: 65, defaultQuantity: 5 }
        ]
      }
    ],
    defaultChecklists: [
      'Teste de estanqueidade com Nitrogênio pressurizado a 350 PSI',
      'Procedimento de vácuo na linha atingindo menos de 500 microns no vacuômetro',
      'Verificação do caimento e escoamento livre da linha de dreno de água',
      'Medição de corrente elétrica (Amperes) e superaquecimento dentro dos parâmetros do fabricante'
    ],
    defaultWarrantyTerms: 'Garantia de 12 meses na instalação mecânica e conexões de cobre. A garantia do equipamento segue os termos do fabricante autorizado.',
    defaultPaymentTerms: 'Entrada 50% na aprovação + 50% após o comissionamento e teste térmico.',
    defaultObservations: [
      'Ponto elétrico com disjuntor dedicado e tomada compatível deve estar disponível no local.',
      'Furos em vigas de concreto armado ou andaimes acima de 4 metros serão orçados à parte.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 5. BELEZA, ESTÉTICA, MANICURE & CABELO (COM AGENDA)
  // ────────────────────────────────────────────────────────────────────────────
  estetica: {
    nicheKey: 'estetica',
    displayName: 'Beleza, Estética, Manicure & Cabelo',
    cluster: 'care_estetica',
    selectorGroups: [
      {
        id: 'procedimentos_unhas',
        title: 'Unhas & Manicure',
        items: [
          { id: 'manicure_pedicure', label: 'Manicure + Pedicure Tradicional', defaultPrice: 65, durationMinutes: 60 },
          { id: 'alongamento_gel', label: 'Alongamento em Gel / Fibra de Vidro', defaultPrice: 160, durationMinutes: 120 },
          { id: 'manutencao_gel', label: 'Manutenção de Alongamento em Gel', defaultPrice: 95, durationMinutes: 90 },
          { id: 'blindagem_unhas', label: 'Blindagem de Unhas Naturais', defaultPrice: 70, durationMinutes: 45 }
        ]
      },
      {
        id: 'cabelo_quimica',
        title: 'Cabelos & Coloração',
        items: [
          { id: 'corte_escova', label: 'Corte Feminino + Escova Modelada', defaultPrice: 110, durationMinutes: 60 },
          { id: 'mechas_loiro', label: 'Mechas / Morena Iluminada com Tratamento', defaultPrice: 380, durationMinutes: 180 },
          { id: 'progressiva_sem_formol', label: 'Alisamento Orgânico / Progressiva', defaultPrice: 220, durationMinutes: 150 },
          { id: 'cronograma_capilar', label: 'Sessão de Cronograma Capilar com Ozônio', defaultPrice: 130, durationMinutes: 60 }
        ]
      },
      {
        id: 'estetica_corporal_facial',
        title: 'Estética & Pacotes',
        items: [
          { id: 'limpeza_pele', label: 'Limpeza de Pele Profunda com Extração', defaultPrice: 140, durationMinutes: 75 },
          { id: 'pacote_drenagem_5x', label: 'Pacote 5 Sessões Drenagem Linfática', defaultPrice: 350, durationMinutes: 60, defaultQuantity: 5 },
          { id: 'design_sobrancelhas', label: 'Design de Sobrancelhas com Henna', defaultPrice: 55, durationMinutes: 40 },
          { id: 'depilacao_cera', label: 'Depilação Completa com Cera Quente', defaultPrice: 110, durationMinutes: 60 }
        ]
      }
    ],
    defaultChecklists: [
      'Ficha de Anamnese digital preenchida e assinada pela cliente',
      'Teste de mecha / sensibilidade cutânea realizado 24h antes para químicas fortes',
      'Desinfecção de bancada e uso de instrumentos 100% esterilizados em autoclave',
      'Kit descartável individual aberto na presença da cliente'
    ],
    defaultWarrantyTerms: 'Garantia de retoque gratuito de até 5 dias para descolamento precoce de unhas em gel ou ajuste de corte.',
    defaultPaymentTerms: 'Pagamento ao final do atendimento ou 50% de sinal para reserva de pacotes e noivas.',
    defaultObservations: [
      'Tolerância de atraso de até 15 minutos para manter a pontualidade da grade de horários.',
      'Cancelamentos devem ser comunicados com no mínimo 4 horas de antecedência.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 6. PINTURA, ACABAMENTO & REFORMAS
  // ────────────────────────────────────────────────────────────────────────────
  pintura: {
    nicheKey: 'pintura',
    displayName: 'Pintura Residencial, Predial & Texturas',
    cluster: 'campo_obras',
    selectorGroups: [
      {
        id: 'preparacao_superficie',
        title: 'Preparação de Parede',
        items: [
          { id: 'lixamento_massa', label: 'Emassamento Completo com Massa Corrida/Acrílica (m²)', defaultPrice: 22 },
          { id: 'aplicacao_selador', label: 'Aplicação de Fundo Preparador / Selador (m²)', defaultPrice: 10 },
          { id: 'tratamento_trincas', label: 'Tratamento de Trincas com Fita Telada e Selante', defaultPrice: 35, defaultQuantity: 3 }
        ]
      },
      {
        id: 'pintura_acabamento',
        title: 'Pintura & Efeitos',
        items: [
          { id: 'pintura_duas_demaos', label: 'Pintura Acrílica Standard - 2 Demãos (m²)', defaultPrice: 18, defaultQuantity: 50 },
          { id: 'efeito_cimento_queimado', label: 'Aplicação de Efeito Cimento Queimado / Mármore (m²)', defaultPrice: 55, defaultQuantity: 15 },
          { id: 'pintura_portas_janelas', label: 'Pintura em Esmalte Sintético de Porta com Batente', defaultPrice: 120, defaultQuantity: 2 },
          { id: 'textura_projetada', label: 'Aplicação de Textura Rústica ou Projetada (m²)', defaultPrice: 30, defaultQuantity: 40 }
        ]
      }
    ],
    defaultChecklists: [
      'Pisos, rodapés e móveis 100% isolados com lona plástica e fita crepe de alta aderência',
      'Nível de umidade da parede verificado antes da aplicação da primeira demão',
      'Intervalo mínimo entre demãos respeitado conforme orientação técnica do fabricante da tinta',
      'Limpeza completa do ambiente com remoção das fitas sem resíduos de cola'
    ],
    defaultWarrantyTerms: 'Garantia de 1 ano contra descamação por falha de aplicação da mão de obra, desde que respeitadas as condições originais de alvenaria sem infiltrações estruturais.',
    defaultPaymentTerms: 'Entrada 40% no isolamento + 30% no emassamento + 30% na entrega das chaves.',
    defaultObservations: [
      'Cálculo de metragem considera altura vezes largura com desconto proporcional de vãos acima de 2m².',
      'Tintas e complementos podem ser fornecidos pelo cliente ou incluídos no Centro de Custos R-MAX.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 7. MARCENARIA & MÓVEIS PLANEJADOS
  // ────────────────────────────────────────────────────────────────────────────
  marcenaria: {
    nicheKey: 'marcenaria',
    displayName: 'Marcenaria & Móveis Planejados',
    cluster: 'campo_obras',
    selectorGroups: [
      {
        id: 'ambientes_planejados',
        title: 'Mobiliário por Ambiente',
        items: [
          { id: 'cozinha_planejada', label: 'Armários de Cozinha em MDF 18mm com Amortecedor (m linear)', defaultPrice: 1200, defaultQuantity: 3 },
          { id: 'painel_ripado_sala', label: 'Painel Ripado para TV com Fita de LED Embutida', defaultPrice: 1400 },
          { id: 'guarda_roupa_embutido', label: 'Guarda-Roupa / Closet com Portas de Correr e Espelho', defaultPrice: 3200 },
          { id: 'gabinete_banheiro', label: 'Gabinete Suspenso para Banheiro em MDF Ultra Naval', defaultPrice: 650 }
        ]
      },
      {
        id: 'ferragens_acabamentos',
        title: 'Ferragens & Acessórios',
        items: [
          { id: 'dobradica_slow', label: 'Par de Dobradiças com Amortecimento Slow Motion', defaultPrice: 35, isMaterial: true, defaultQuantity: 6 },
          { id: 'corredica_invisivel', label: 'Par de Corrediças Ocultas com Amortecedor', defaultPrice: 85, isMaterial: true, defaultQuantity: 4 },
          { id: 'puxador_perfil', label: 'Puxador Perfil Gola em Alumínio Anodizado (metro)', defaultPrice: 45, isMaterial: true, defaultQuantity: 3 }
        ]
      }
    ],
    defaultChecklists: [
      'Medições milimétricas (LxAxP) conferidas no local após reboco e piso finalizados',
      'Posicionamento de pontos elétricos e hidráulicos checados para corte na marcenaria',
      'Planta executiva com detalhamento de portas e gavetas assinada pelo cliente',
      'Nivelamento e fixação com buchas adequadas ao tipo de alvenaria/drywall'
    ],
    defaultWarrantyTerms: 'Garantia de 5 anos na estrutura do MDF contra empenamento e 1 ano nas ferragens móveis.',
    defaultPaymentTerms: 'Entrada 50% para compra de chapas e ferragens + 50% na montagem final.',
    defaultObservations: [
      'Prazo de fabricação e montagem: 30 a 45 dias úteis após assinatura do projeto final.',
      'Tampo de granito, cubas e eletrodomésticos embutidos devem ser instalados após os móveis.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 8. CONFEITARIA, SALGADOS & GASTRONOMIA DE FESTA
  // ────────────────────────────────────────────────────────────────────────────
  confeitaria: {
    nicheKey: 'confeitaria',
    displayName: 'Confeitaria, Salgados & Gastronomia',
    cluster: 'producao_food',
    selectorGroups: [
      {
        id: 'bolos_decorados',
        title: 'Bolos & Tortas',
        items: [
          { id: 'bolo_chantininho_kg', label: 'Bolo Decorado em Chantininho (por kg)', defaultPrice: 85, defaultQuantity: 2 },
          { id: 'bolo_pasta_americana', label: 'Bolo Artístico em Pasta Americana (por kg)', defaultPrice: 120, defaultQuantity: 3 },
          { id: 'topo_bolo_personalizado', label: 'Topo de Bolo em Papelaria Personalizada / Acrílico', defaultPrice: 45, isMaterial: true },
          { id: 'bento_cake', label: 'Bentô Cake com Frase Personalizada', defaultPrice: 45 }
        ]
      },
      {
        id: 'doces_salgados',
        title: 'Doces & Salgados de Festa',
        items: [
          { id: 'cento_salgados_fritos', label: 'Cento de Salgados Fritos (Coxinha, Kibe, Queijo)', defaultPrice: 110, defaultQuantity: 2 },
          { id: 'cento_salgados_assados', label: 'Cento de Salgados Assados (Empada, Esfiha)', defaultPrice: 130 },
          { id: 'cento_brigadeiros_gourmet', label: 'Cento de Brigadeiros Gourmet (Cacau 50%, Ninho, Pistache)', defaultPrice: 160 }
        ]
      }
    ],
    defaultChecklists: [
      'Ficha de ingredientes e alergênicos (Leite, Glúten, Castanhas) validada com o cliente',
      'Horário exato de entrega/retirada alinhado para preservação da refrigeração',
      'Embalagem reforçada com base estruturada para transporte automotivo seguro'
    ],
    defaultWarrantyTerms: 'Garantia de frescor dos produtos preparados artesanalmente no dia do evento. O transporte e consumo adequado seguem as instruções de conservação fornecidas.',
    defaultPaymentTerms: 'Entrada obrigatória de 50% via PIX para reserva de data e compra de insumos + 50% na retirada/entrega.',
    defaultObservations: [
      'Encomendas sujeitas à disponibilidade de agenda com no mínimo 4 dias de antecedência.',
      'Taxa de entrega via carro de aplicativo calculada conforme a distância no dia do evento.'
    ]
  },

  // ────────────────────────────────────────────────────────────────────────────
  // 9. CORTE A LASER, CNC, BRINDES & PERSONALIZADOS
  // ────────────────────────────────────────────────────────────────────────────
  laser_cnc: {
    nicheKey: 'laser_cnc',
    displayName: 'Corte a Laser, CNC, Brindes & Personalizados',
    cluster: 'producao_food',
    selectorGroups: [
      {
        id: 'materiais_chapas',
        title: 'Chapas & Matéria-Prima',
        items: [
          { id: 'chapa_mdf_3mm', label: 'Chapa MDF 3mm Cru / Branco (Corte por metro/área)', defaultPrice: 45, isMaterial: true },
          { id: 'chapa_acrilico_cast', label: 'Chapa Acrílico Cast Cristal 2mm/3mm', defaultPrice: 120, isMaterial: true },
          { id: 'acrilico_espelhado', label: 'Acrílico Espelhado Dourado / Prata / Rosé', defaultPrice: 160, isMaterial: true },
          { id: 'madeira_teca_pinus', label: 'Madeira Nobre / Pinus / Teca para Tábuas', defaultPrice: 85, isMaterial: true }
        ]
      },
      {
        id: 'maquina_gravacao',
        title: 'Tempo de Máquina & Gravação',
        items: [
          { id: 'minuto_laser_co2', label: 'Tempo de Máquina Laser CO2 (por minuto de corte)', defaultPrice: 4.5, defaultQuantity: 15 },
          { id: 'gravacao_copo_stanley', label: 'Gravação a Laser em Copo Térmico / Squeeze (unidade)', defaultPrice: 25, defaultQuantity: 4 },
          { id: 'gravacao_caneta_metal', label: 'Gravação a Laser em Canetas / Chaveiros Metal (unidade)', defaultPrice: 8, defaultQuantity: 20 },
          { id: 'hora_router_cnc', label: 'Hora Máquina Router CNC (Usinagem 3D e Rebaixo)', defaultPrice: 180 }
        ]
      },
      {
        id: 'produtos_brindes',
        title: 'Brindes & Produtos Prontos',
        items: [
          { id: 'trofeu_acrilico_madeira', label: 'Troféu em Acrílico com Base de Madeira Maciça', defaultPrice: 95, defaultQuantity: 3 },
          { id: 'topo_bolo_acrilico', label: 'Topo de Bolo em Acrílico Espelhado com Nome e Idade', defaultPrice: 55 },
          { id: 'kit_brindes_corporativo', label: 'Kit Corporativo VIP (Copo Gravado + Bloco + Caneta Laser)', defaultPrice: 135, defaultQuantity: 10 },
          { id: 'cento_chaveiros_personalizados', label: 'Cento de Chaveiros Personalizados em MDF/Acrílico', defaultPrice: 220 },
          { id: 'letreiro_luminoso_led', label: 'Letreiro / Placa Decorativa em Acrílico com Fita LED Neon', defaultPrice: 380 }
        ]
      }
    ],
    defaultChecklists: [
      'Arquivo vetorizado (DXF / SVG / CDR / AI) conferido em escala 1:1 e curvas fechadas',
      'Parâmetros de potência, velocidade e foco da lente calibrados para a espessura da chapa',
      'Película de proteção mantida no acrílico durante o corte para evitar marcas de queima',
      'Limpeza com álcool isopropílico e descarte cuidadoso de rebarbas/cinzas',
      'Teste de encaixe e tolerância (Kerf) realizado em protótipo antes de rodar o lote'
    ],
    defaultWarrantyTerms: 'Garantia de fidelidade ao layout digital vetorizado aprovado pelo cliente, com precisão milimétrica de corte. A garantia não cobre quebras por impacto ou mau uso pós-entrega.',
    defaultPaymentTerms: 'Entrada obrigatória de 50% para compra de chapas e corte + 50% na expedição/retirada.',
    defaultObservations: [
      'Prazos de fabricação contam a partir da aprovação final do layout digital.',
      'Variações de tonalidade e veios na madeira/MDF são características naturais da matéria-prima.',
      'Amostras físicas prévias para grandes lotes são orçadas com custo de prototipagem.'
    ]
  }
};
